import React from "react";
import styles from "../style.module.scss";
import Text from "components/Text";
import PdcIcon from "../../../assets/images/pdc-icon.png";


export default function LatestCard() {
  return (
    <div className={styles["latest-card-box"]}>
      <div className={styles["latest-event-icon"]}>
        <img src={PdcIcon} alt="event-icon" />
      </div>
      <div>
        <Text className={styles["latest-event-heading"]}>
          PDC (Pacific Dental Conference)
        </Text>
      </div>

      <div className={styles["latest-event-detail"]}>
        <div className="d-flex align-items-center">
          <div className={styles["custom-dot"]}></div>
          <span className={styles["event-date"]}>March 5 - 6, 2026</span>
        </div>
        <div className="d-flex align-items-center">
          <div className={styles["custom-dot"]}></div>
          <span className={styles["booth-id"]}>Booth 737</span>
        </div>
        <div className="d-flex align-items-center">
          <div className={styles["custom-dot"]}></div>
          <span className={styles["event-location"]}>
            Vancouver, BC, Canada
          </span>
        </div>
      </div>
      <div className={styles["event-button-box"]}>
        <a
          href="https://meetings.hubspot.com/madjid-rassamanesh/pdc2026"
          target="_blank"
          rel="noopener noreferrer"
          className={styles["latest-custom-events-button"]}
        >
          <span className="button button-round button-shadow"> Book an Onsite Demo</span>
        </a>


        <a
          href="https://pacificdentalconference.com/"
          target="_blank"
          rel="noopener noreferrer"          
          className={styles["view-event-detail"]}
        >
          View Tradeshow Details
        </a>
      </div>
    </div>
  );
}
